import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Modal, Select, Button, Input, Icon, DatePicker } from 'antd'
import { commissions, infoMsg } from '@services/api'
import {
    calendarBug,
    container,
    editPopupSecondRow,
    editPopupSums,
    input_element,
    unsetMargin
} from '@pages/AgentCommissions/Reports/style.scss'
import moment from 'moment'
import { isNumber } from '@utils/index'

const { Option } = Select
const { TextArea } = Input

const messageOptions = {
    INCORRECT_INVOICE: 'חשבונית שגויה',
    CUSTOM_MESSAGE: 'טקסט חופשי'
}

@inject((store: any) => {
    const { popupStore, authStore } = store
    return { popupStore, authStore }
})
@observer
export default class EditCommissionRow extends Component<any, any> {
    constructor(props) {
        super(props)
        this.state = {
            selectedOption: messageOptions.INCORRECT_INVOICE, // Default option
            price: null,
            loading: false,
            agent_name: null,
            agent_id: null,
            agent_search_id: null,
            date: null,
            customText: '' // For the custom form's TextArea
        }
    }

    closePopup = () => {
        const {
            popupStore: { togglePopup }
        } = this.props
        togglePopup('')
    }

    onAgentSearch = (event, key) => {
        this.setState({ [key]: event.value.replace(/[^0-9]/g, '') }, () => {
            if (!this.state.agent_search_id) this.setState({ agent_name: null, agent_id: null })
            if (this.state.agent_search_id && event.value.replace(/[^0-9]/g, ''))
                commissions
                    .findUserForCommission({ id: this.state.agent_search_id, isAgent: true })
                    .then(({ data, status }) => {
                        if (status === 200) return this.setState({ agent_name: data.name, agent_id: data.id.toString() })
                        if (status === 201) return this.setState({ agent_name: data.name, agent_id: null })
                    })
                    .catch(() => alert('אירעה שגיאה'))
        })
    }

    onNumberInput = (event, key, _, reg) => {
        let value = event.value
        value = value.replace(reg, '')
        if (value.startsWith('0')) {
            value = value.slice(1)
        }
        _.setState({ [key]: value })
    }

    onDateEvent = (date, dateString, key) => {
        this.setState({ [key]: moment(dateString).format('DD/MM/YYYY') })
    }

    // Synchronous in-flight guard: state updates are asynchronous, so a double-click could pass a state check twice.
    // Cleared when the request settles (success or failure), so a later intentional send still works.
    sending = false

    sendSms = () => {
        if (this.sending) return
        this.sending = true
        const { events } = this.props
        const { price, agent_id, date, customText, selectedOption } = this.state
        this.setState({ loading: true })

        const payload = {
            agent_id,
            msg_type: Object.keys(messageOptions).find(key => messageOptions[key] === selectedOption), // This will send 'INCORRECT_INVOICE' or 'CUSTOM_MESSAGE'

        }

        if (payload.msg_type === "INCORRECT_INVOICE") {
            payload['price'] = price
            payload['date'] = date
            infoMsg
                .sendFinanceSms(payload)
                .then(res => {
                    events.setState({ sendSms: false })
                    alert('נשלח בהצלחה')
                })
                .catch(() => alert('שגיאה, הודעה לא נשלחה'))
                .finally(() => {
                    this.sending = false
                    this.setState({ loading: false })
                })
        } else {
            payload['custom_text'] = customText.replace(/\n/g, '\n')
            infoMsg
                .sendFinanceSms(payload)
                .then(res => {
                    events.setState({ sendSms: false })
                    alert('נשלח בהצלחה')
                })
                .catch(() => alert('שגיאה, הודעה לא נשלחה'))
                .finally(() => {
                    this.sending = false
                    this.setState({ loading: false })
                })
        }
    }


    render() {
        const {
            popupStore: { popupType }
        } = this.props
        const { closePopup, onAgentSearch, onNumberInput, onDateEvent, sendSms } = this
        const { selectedOption, agent_search_id, agent_id, agent_name, price, date, loading, customText } = this.state
        const btnInner = loading ? <Icon type="loading" /> : 'שליחה'
        const isSubmit = selectedOption === messageOptions.INCORRECT_INVOICE
            ? !(agent_id && isNumber(price) && price > 0 && date)
            : !agent_id || !customText

        return (
            <Modal
                title={`הודעה לסוכן`}
                visible={popupType === 'commissionSmsPopup'}
                onCancel={closePopup}
                footer={null}
            >
                <div className={container}>
                    <div style={{ marginBottom: '20px' }}>
                        <Select
                            value={selectedOption}
                            onChange={value => this.setState({ selectedOption: value })}
                            style={{ width: '100%' }}
                        >
                            <Option value={messageOptions.INCORRECT_INVOICE}>{messageOptions.INCORRECT_INVOICE}</Option>
                            <Option value={messageOptions.CUSTOM_MESSAGE}>{messageOptions.CUSTOM_MESSAGE}</Option>
                        </Select>
                    </div>
                    <div className={editPopupSecondRow} style={{ width: '100%' }}>
                        <div className={editPopupSums}>
                            <div>מזהה סוכן</div>
                            <Input
                                className={`${input_element} ${unsetMargin}`}
                                value={agent_search_id}
                                onInput={({ target }) => onAgentSearch(target, 'agent_search_id')}
                            />
                        </div>
                        {agent_id ? <Icon type={'check'} style={{ color: 'green', marginTop: '20px' }} /> : null}
                        <div className={editPopupSums}>
                            <div>שם סוכן</div>
                            <Input
                                placeholder={agent_name}
                                style={{ width: '290px' }}
                                className={`${input_element} ${unsetMargin}`}
                                disabled={true}
                            />
                        </div>
                    </div>
                    {selectedOption === messageOptions.INCORRECT_INVOICE ? (
                        <div>
                            <div className={editPopupSecondRow} style={{ width: '100%' }}>
                                <div className={editPopupSums}>
                                    <div>{'סכום'}</div>
                                    <Input
                                        className={`${input_element} ${unsetMargin}`}
                                        value={price}
                                        onInput={({ target }) => onNumberInput(target, 'price', this, /[^0-9\.-]/g)}
                                    />
                                </div>
                                <div className={editPopupSums}>
                                    <div>{'תאריך'}</div>
                                    <DatePicker
                                        className={calendarBug}
                                        placeholder={date ? date : 'בחרו תאריך'}
                                        style={{ border: 'unset', width: '290px' }}
                                        onChange={(date, dateString) => onDateEvent(date, dateString, 'date')}
                                        disabledDate={current => current && current < moment().startOf('day')}
                                    />
                                </div>
                            </div>
                            <div>
                                {!isSubmit ? (
                                    <>
                                        שלום {agent_name ? agent_name : '____'},<br />
                                        הסכום הנקוב בחשבונית שהופקה שגוי.<br />
                                        יש להפיק חשבונית מס עם הסכום התקין: {price ? price : '____'} ₪<br />
                                        ולשלוח לכתובת heshm@mediwho.co.il<br />
                                        עד לתאריך {date ? date : '____'}<br />
                                        לבירורים נוספים ניתן לפנות לדסק הסוכנים
                                    </>
                                ) : ('')}
                            </div>
                        </div>
                    ) : (
                        <div>
                            <div>
                                <div>תיאור</div>
                                <TextArea
                                    rows={4}
                                    value={customText}
                                    onChange={({ target }) => this.setState({ customText: target.value })}
                                />
                            </div>
                            <div>
                                {!isSubmit ? (
                                    <>
                                        שלום {agent_name ? agent_name : '____'},<br />
                                        {customText.split('\n').map((line, index) => (
                                            <React.Fragment key={index}>
                                                {line}
                                                <br />
                                            </React.Fragment>
                                        ))}
                                    </>
                                ) : ('')}
                            </div>
                        </div>
                    )}
                    <div style={{ marginTop: '20px' }}>
                        <Button disabled={isSubmit || loading} type="primary" onClick={sendSms}>
                            {btnInner}
                        </Button>
                    </div>
                </div>
            </Modal>
        )
    }
}
